import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import CreatePlayerModal from '../../players/CreatePlayerModal';
import PlayerWidget from '../../components/PlayerWidget';

const ClassroomCard = ({ type, components, prefect }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const iconStyle = {
    transition: 'transform 0.3s ease',
    transform: isHovered ? 'scale(1.4)' : 'scale(1)',
    cursor: isHovered ? 'pointer' : 'inherit',
    color: isHovered ? 'var(--falcon-primary)' : 'var(--falcon-secondary)'
  };

  return (
    <>
      <CreatePlayerModal
        playerType={type}
        modalShow={modalShow}
        setModalShow={setModalShow}
      />
      <Card className="mb-3">
        <Card.Header>
          <Row className="flex-between-center flex-column flex-sm-row">
            <Col sm="auto" className="d-flex align-items-center pe-0">
              <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
                {type == 'S' ? 'Studenti' : 'Professori'}
              </h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="px-1 py-0">
          {/* <div className="text-center">
            <h5 className="lead text-700 m-4">
              Inizia subito ad aggiungere{' '}
              {type == 'S' ? (
                <span>
                  gli <strong>studenti</strong>
                </span>
              ) : (
                <span>
                  i <strong>professori</strong>
                </span>
              )}{' '}
              della tua classe!
            </h5>
          </div> */}
          <Row className="text-center fs--1">
            {components.map(function (component, index) {
              if (!component.deleted) {
                return (
                  <Col
                    xs={6}
                    md={4}
                    lg={3}
                    xxl={2}
                    className="mb-1"
                    key={index}
                  >
                    <PlayerWidget
                      {...component}
                      playerType={type}
                      type="complete"
                    />
                  </Col>
                );
              }
            })}
            {prefect && (
              <Col xs={6} md={4} lg={3} xxl={2} className="mb-1">
                <div className="p-3 h-100 d-flex align-items-center">
                  <div
                    className="icon-circle icon-circle-secondary fs-7"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <FontAwesomeIcon
                      icon="user-plus"
                      style={iconStyle}
                      onClick={() => setModalShow(true)}
                    />
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

ClassroomCard.propTypes = {
  type: PropTypes.string.isRequired,
  components: PropTypes.array.isRequired,
  prefect: PropTypes.bool.isRequired
};

export default ClassroomCard;
